/** Tooltip on the ? hint where the clear-slot × would be on locked rosters. */
export const SCHEDULED_GAME_LOCK_TOOLTIP =
  'This is a scheduled game. Use × to cancel the entire game and return players to the queue.';

/** Info hint for Manage → Scheduled games (HostAdminCollapsibleSection). */
export const SCHEDULED_GAMES_HOST_INFO =
  'Add, reorder, or remove scheduled games here. Use × on a game to cancel it and return players to the queue. Once a game is on court or upcoming, × on the court or upcoming slot also cancels the entire scheduled game — you cannot remove one player only.';

/** Short note shown at the top of the scheduled games list. */
export const SCHEDULED_GAMES_LIST_NOTE =
  '× on a scheduled game here, or on the linked court/upcoming slot, cancels the entire game and returns players to the queue.';

/** Shown when drag-and-drop is blocked or the linked scheduled game cannot be resolved. */
export const SCHEDULED_GAME_ROSTER_LOCKED_MESSAGE =
  'This is a scheduled game. Remove or cancel it using × on the court, upcoming slot, or in Scheduled games.';

const PLACED_STATUSES = new Set(['placed', 'on_court']);

/**
 * Copy for the scheduled-game cancel ConfirmModal.
 *
 * @param {{ status?: string }|null|undefined} game
 * @param {'sidebar'|'court_player'|'court_clear'|'upcoming_clear'} [cancelTrigger]
 */
export function getScheduledGameCancelModalCopy(game, cancelTrigger = 'sidebar') {
  const isPlacedOrOnCourt = PLACED_STATUSES.has(game?.status);

  if (cancelTrigger === 'court_player') {
    return {
      title: isPlacedOrOnCourt ? 'Cancel in-progress scheduled game?' : 'Cancel scheduled game?',
      message:
        'This is a scheduled game. Removing a player cancels the entire game — you cannot remove one player only. All players return to the queue and this court is cleared.',
      confirmText: 'Cancel scheduled game',
    };
  }

  if (cancelTrigger === 'court_clear') {
    return {
      title: isPlacedOrOnCourt ? 'Cancel in-progress scheduled game?' : 'Cancel scheduled game?',
      message:
        'Clearing this court cancels the scheduled game. All players return to the queue.',
      confirmText: 'Cancel scheduled game',
    };
  }

  if (cancelTrigger === 'upcoming_clear') {
    return {
      title: 'Cancel scheduled game?',
      message:
        'Clearing this upcoming match cancels the scheduled game. All players return to the queue.',
      confirmText: 'Cancel scheduled game',
    };
  }

  // Sidebar (default)
  return {
    title: isPlacedOrOnCourt ? 'Cancel in-progress scheduled game?' : 'Remove scheduled game?',
    message: isPlacedOrOnCourt
      ? 'Cancel this scheduled game? Players will return to the queue and the upcoming slot will be cleared.'
      : 'Remove this scheduled game? Players will be available for matchmaking again.',
    confirmText: isPlacedOrOnCourt ? 'Cancel scheduled game' : 'Remove scheduled game',
  };
}
